import React from "react";
import Avatar from "../../components/inputs/Avatar";
import { calculateDurationInHoursAndMin } from "../../utils/serviceUtilities";
import LearningPathCardImage from "./LearningPathCardImage";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const AdminLearningPathdetailsCard = ({
  course,
  listDetails,
  smallCard,
  onRemove,
}) => {
  const duration = calculateDurationInHoursAndMin(course.video_duration);
  const { t } = useTranslation(["learningPaths"]);

  return (
    <div
      className={`card-style learinig-path-card learinig-path-details-card ${
        smallCard ? "small-card" : ""
      }`}
    >
      <LearningPathCardImage
        src={course?.image_url}
        alt={course?.title || ""}
      />

      <div className="learinig-path-card__content">
        <div className="course-label-slot mb-1">
          {course?.topics?.length ? (
            <span
              className="course-label"
              style={{ backgroundColor: `${course.topics[0].color}` }}
            >
              {course.topics[0].title}
            </span>
          ) : (
            <span className="course-label course-label--empty" aria-hidden />
          )}
        </div>
        <h2 className="card-title mb-2">{course.title}</h2>
        <ul className="list-details mb-3 mt-1">
          <li>
            <Avatar
              width="24"
              height="24"
              avatarUrl={course.tutor?.avatar_url}
            />
            <p className="font_14 font-color-grey ms-1 mb-0">
              {course.tutor?.name}
            </p>
          </li>
        </ul>
        {listDetails && (
          <ul className="list-details">
            <li>
              <span className="fas fa-play-circle fa-fw font-color-grey"></span>
              <p className="font_14 font-color-grey ms-1 mb-0">
                {course.lessons_count} {t("learningPaths:lesson")}
              </p>
            </li>
            <li>
              <span className="fas fa-question-circle fa-fw font-color-grey"></span>
              <p className="font_14 font-color-grey ms-1 mb-0">
                4 {t("learningPaths:question")}
              </p>
            </li>
            <li>
              <span className="fas fa-clock fa-fw font-color-grey"></span>
              <span className="font_14 font-color-grey ms-1 mb-0">
                {duration.hours > 0 && (
                  <span>
                    {duration.hours} {t("learningPaths:hour")}{" "}
                  </span>
                )}
                {duration.hours > 0 && duration.minutes > 0 && ":"}
                {duration.minutes > 0 && (
                  <span>
                    {duration.minutes} {t("learningPaths:minutes")}
                  </span>
                )}
              </span>
            </li>
          </ul>
        )}
      </div>

      {onRemove && (
        <div className="learinig-path-card__btn admin-learning-path-details__course-remove">
          <button
            type="button"
            className="btn btn-red-light-color font-15 admin-learning-path-details__remove-course-btn"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(course);
            }}
            aria-label={t("learningPaths:removeFromTrack")}
          >
            <span className="fas fa-trash fa-fw me-2" aria-hidden="true"></span>
            {t("learningPaths:removeFromTrack")}
          </button>
        </div>
      )}
    </div>
  );
};

AdminLearningPathdetailsCard.propTypes = {
  course: PropTypes.object.isRequired,
  listDetails: PropTypes.bool,
  smallCard: PropTypes.bool,
  onRemove: PropTypes.func,
};

export default AdminLearningPathdetailsCard;
